import React from 'react';

function HeroSection() {
  const styles = {
    section: {
      position: 'relative',
      width: '100%',
      backgroundColor: '#FFFFFF'
    },
    heroImage: {
      width: '100%',
      height: 'auto',
      display: 'block'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 0.5
    },
    contentLayer: {
      position: 'absolute',
      inset: 0,
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column'
    },
    blackBanner: {
      width: '100%',
      maxWidth: 1920,
      height: 60,
      background: '#090909',
      opacity: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 clamp(24px, 5vw, 80px)',
      gap: 32,
      flexShrink: 0,
      zIndex: 2
    },
    bannerItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: '14px',
      color: '#FFFFFF',
      textDecoration: 'none'
    },
    bannerIcon: {
      width: 20,
      height: 20,
      objectFit: 'contain'
    },
    header: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px clamp(24px, 5vw, 80px)',
      flexWrap: 'wrap',
      gap: 16,
      background: '#FFFFFF',
      flexShrink: 0
    },
    logoWrap: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none'
    },
    logoImg: {
      height: 42,
      objectFit: 'contain',
      display: 'block'
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      gap: 32,
      flexWrap: 'wrap'
    },
    navLink: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: '16px',
      color: '#090909',
      textDecoration: 'none'
    },
    navBtn: {
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: '14px',
      padding: 0,
      background: 'transparent',
      color: '#090909',
      textDecoration: 'none',
      border: 'none',
      cursor: 'pointer',
      textTransform: 'none'
    },
    redPanelImg: {
      position: 'absolute',
      left: 250,
      top: '45%',
      transform: 'translateY(-50%)',
      width: 150,
      height: 'auto',
      display: 'block'
    },
    heroTitles: {
      position: 'absolute',
      top: '42%',
      left: 280,
      transform: 'translateY(-50%)',
      zIndex: 3,
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    },
    redLine: {
      width: 160,
      height: 2,
      background: '#FFFFFF',
      flexShrink: 0
    },
    titlePrimary: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 44,
      lineHeight: '100%',
      letterSpacing: '0',
      color: '#FFFFFF',
      margin: 0,
      textTransform: 'uppercase'
    },
    titleSecondary: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 30,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      color: '#FFFFFF',
      margin: '8px 0 0 0',
      textTransform: 'uppercase'
    },
    titleTertiary: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 24,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      color: '#FFFFFF',
      margin: '8px 0 0 0',
      textTransform: 'uppercase'
    },
    rightBlock: {
      position: 'absolute',
      top: '55%',
      transform: 'translateY(-50%)',
      flex: 1,
      minWidth: 280,
      maxWidth: 580,
      marginLeft: 300,
      zIndex: 3,
      display: 'flex',
      alignItems: 'center',
      gap: 12
    },
    description: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: 1.4,
      color: '#FFFFFF',
      margin: 0
    }
  };

  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Projects', href: '/#projects' },
    { label: 'Blogs', href: '/blogs' }
  ];

  var path = window.location.pathname;
  var hash = window.location.hash;
  function isActive(label) {
    if (label === 'Home') return path === '/' || path === '/index.html';
    if (label === 'About') return path.indexOf('/about') === 0;
    if (label === 'Services') return path.indexOf('/services') === 0;
    if (label === 'Projects') return hash === '#projects';
    if (label === 'Blogs') return path.indexOf('/blogs') === 0 || hash === '#blogs';
    return false;
  }

  return React.createElement('section', { style: styles.section, className: 'hero-section' },
    React.createElement('img', {
      src: '/Hero.png',
      alt: 'Sunrise Properties - Precision Piling',
      style: styles.heroImage
    }),
    React.createElement('div', { style: styles.overlay }),
    React.createElement('div', { style: styles.contentLayer },
      React.createElement('div', { style: styles.blackBanner, className: 'hero-black-banner' },
        React.createElement('a', { href: 'mailto:sunriseinfrajpr@gmail.com', style: styles.bannerItem },
          React.createElement('img', { src: '/MailIcon.png', alt: '', style: styles.bannerIcon }),
          'sunriseinfrajpr@gmail.com'
        ),
        React.createElement('a', { href: 'tel:+919790633555', style: styles.bannerItem },
          React.createElement('img', { src: '/PhoneIcon.png', alt: '', style: styles.bannerIcon }),
          '+91-9790633555'
        )
      ),
      React.createElement('header', { style: styles.header },
        React.createElement('a', { href: '/', style: styles.logoWrap },
          React.createElement('img', { src: '/SunRiseLogo.jpg', alt: 'Sunrise - Engineering our future', style: styles.logoImg })
        ),
        React.createElement('nav', { style: styles.nav, className: 'hero-nav' },
          navItems.map(function (item, i) {
            return React.createElement('a', {
              key: i,
              href: item.href,
              style: styles.navLink,
              className: 'main-nav-link' + (isActive(item.label) ? ' main-nav-link-active' : '')
            }, item.label);
          }),
          React.createElement('a', { href: '/#contact', style: styles.navBtn, className: 'nav-btn-main' }, 'Contact Us')
        )
      ),
      React.createElement('img', {
        src: '/Red.png',
        alt: '',
        style: styles.redPanelImg,
        className: 'hero-red-panel'
      }),
      React.createElement('div', { style: styles.heroTitles, className: 'hero-titles' },
        React.createElement('h1', { style: styles.titlePrimary }, 'PRECISION PILING'),
        React.createElement('p', { style: styles.titleSecondary }, 'POWERFUL FOUNDATIONS'),
        React.createElement('p', { style: styles.titleTertiary }, 'GLOBAL VISION')
      ),
      React.createElement('div', { style: styles.rightBlock, className: 'hero-right-block' },
        React.createElement('div', { style: styles.redLine }),
        React.createElement('p', { style: styles.description },
          'Building the unseen strength beneath iconic structures with advanced technology, expert engineering, and uncompromising quality.'
        )
      )
    )
  );
}

export default HeroSection;
